/**
 * Rótulos puros dos compartilhamentos públicos do laudo QPreço.
 *
 * Extraídos de `pages/AreaQprecoIndex.vue` sem mudança de copy nem de tom.
 */
import { formatDateTime, formatNumber } from './qprecoFormatters';

export const shareStatusLabel = share => {
  const labels = {
    active: 'Ativo',
    revoked: 'Revogado',
    expired: 'Expirado',
    view_limit_reached: 'Limite atingido',
  };
  return labels[share?.status] || (share?.active ? 'Ativo' : 'Inativo');
};

export const shareStatusTone = share => {
  if (share?.active) return 'bg-emerald-50 text-emerald-800';
  if (share?.status === 'revoked') return 'bg-rose-50 text-rose-800';
  if (share?.status === 'expired') return 'bg-amber-50 text-amber-800';
  return 'bg-lais-bg-muted text-lais-text-muted';
};

export const shareEventLabel = eventType => {
  const labels = {
    viewed: 'Visualizado',
    downloaded: 'Download',
    approved: 'Aprovado',
    recommendation_accepted: 'Recomendação aceita',
    recommendation_rejected: 'Recomendação recusada',
    revoked: 'Revogado',
  };
  return labels[eventType] || eventType || 'Evento';
};

export const shareAuditEvents = share =>
  Array.isArray(share?.audit_events) ? share.audit_events : [];

export const shareAuditSummary = share => {
  const latestEvent = shareAuditEvents(share)[0];
  if (latestEvent) {
    return `${shareEventLabel(latestEvent.event_type)} em ${formatDateTime(
      latestEvent.occurred_at
    )}`;
  }
  return `Emitido em ${formatDateTime(share?.issued_at)}`;
};

export const shareViewLimitLabel = share => {
  if (!share?.view_limit) return `${formatNumber(share?.view_count)} acessos`;
  return `${formatNumber(share?.view_count)} de ${formatNumber(
    share.view_limit
  )} acessos`;
};

export const shareCreatorLabel = share =>
  share?.created_by?.name || 'Usuário não informado';

export const shareTokenLabel = share =>
  share?.token_last_four ? `final ${share.token_last_four}` : `ID ${share?.id}`;

export const shareExpirationLabel = share =>
  share?.expires_at
    ? `Expira em ${formatDateTime(share.expires_at)}`
    : 'Sem expiração definida';
